function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.036 26.597l1.333-2.499-2.71 1.34-2.962-8.669-2.967 8.695-2.735-1.333 1.34 2.71-8.672 2.962 5.172 1.764m3.525 1.796l-1.333 2.142 2.71-1.34 2.96 8.672 2.969-8.697 2.735 1.333-1.34-2.71 8.67-2.96-4.706-1.607"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.518 32.24L9.93 36.683l16.883-8.956 18.588-4.442z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.024 29.803A21.327 21.327 0 0127.697 51.13 21.327 21.327 0 016.37 29.803 21.327 21.327 0 0127.697 8.476a21.327 21.327 0 0121.327 21.327z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.394 29.803A23.697 23.697 0 0127.697 53.5 23.697 23.697 0 014 29.803 23.697 23.697 0 0127.697 6.106a23.697 23.697 0 0123.697 23.697z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.698 11.536V7.981M27.698 51.13v-3.555M6.662 29.802h3.555M45.279 29.802h3.555M40.376 16.649l2.37-2.65M15.174 41.845l-2.37 2.65M40.85 41.845l2.37 2.65M15 16.649l-2.37-2.65"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.697,
  cy: 29.803,
  r: 0.592,
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27.699,
  cy: 3.735,
  r: 1.777,
  strokeWidth: 1.002
}));

var SvgCompass = function SvgCompass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Compass.353542c4.svg";
export { ForwardRef as ReactComponent };